<div
    class="w-full h-full flex flex-row items-center justify-between px-1.5 rounded-lg group animation-fade-in-quick"
    [ngClass]="{
        'cursor-pointer': isSelectable,
    }">
    @if (partnerInfo.partner) {
        <fm-avatar
            [sizePx]="36"
            (touchstart)="onTouchStartAvatar($event)"
            (touchend)="onTouchAvatar($event)"
            (pointerenter)="onPointerEnterAvatar($event)"
            (mouseenter)="onMouseEnterAvatar($event)"
            [pTooltip]="tooltipContent"
            [autoHide]="false"
            tooltipPosition="left"
            tooltipStyleClass="profile-preview"
            [isSaved]="partnerInfo.partner?.saved"
            [isQuietMode]="partnerInfo.partner?.preferences.quietMode.value"
            [avatarLocation]="partnerInfo.partner?.profilePhoto" />

        <ng-template #tooltipContent>
            <fm-profile-preview [data]="partnerInfo"></fm-profile-preview>
        </ng-template>
        <!-- Not dismissable: the overlay below owns outside-tap dismissal. PrimeNG's own
             listener (touchstart on iOS) hides the popover, and with it the overlay, before
             the tap's click fires, letting that click fall through and select a timeslot. -->
        <p-popover
            (onShow)="overlayVisible = true"
            (onHide)="overlayVisible = false"
            [dismissable]="false"
            [autoZIndex]="false"
            styleClass="z-[960] !bg-p-content-hover-background"
            #op>
            <fm-profile-preview
                [data]="partnerInfo"
                [showCloseButton]="true"
                (onViewProfileSelected)="closePopover($event)"
                (onClosePopover)="closePopover($event)"></fm-profile-preview>
        </p-popover>

        @if (overlayVisible) {
            <div
                class="fixed inset-0 bg-transparent z-[999] touch-none select-none"
                (pointerdown)="onPointerDownOverlay($event)"
                (click)="onClickOverlay($event)">
            </div>
        }
    }

    @if (hasDirectBookablePartner || hasAvailableGroupMeeting) {
        <div class="ml-auto flex items-center gap-[3px]">
            @if (hasAvailableGroupMeeting) {
                <p-button
                    pTooltip="Group Sessions"
                    [buttonProps]="{ autofocus: false }"
                    (click)="onClickSendTimeslotGroupMeetingsToDynamicPanel($event)"
                    severity="info"
                    [outlined]="true"
                    ariaLabel="Group Sessions"
                    styleClass="h-[36px] bp908:!w-5">
                    <ng-template #icon>
                        <fm-icon name="flower" size="14px" />
                    </ng-template>
                </p-button>
            }

            @if (hasDirectBookablePartner) {
                <p-button
                    [buttonProps]="{ autofocus: false }"
                    (click)="onClickSendTimeslotPartnersToDynamicPanel()"
                    severity="secondary"
                    [outlined]="true"
                    icon="pi pi-star-fill"
                    styleClass="h-[36px] bp908:!w-5" />
            }
        </div>
    }
</div>
